/* ===========================================================
   HOMEAROMA — Theme interactivity
   =========================================================== */
(function () {
  'use strict';

  var HA = window.HA || {};

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function getSectionHTML(htmlString, selector) {
    var doc = new DOMParser().parseFromString(htmlString, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  /* ===========================================================
     HEADER — scroll shadow
     =========================================================== */
  var header = $('[data-site-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ===========================================================
     MOBILE NAV DRAWER
     =========================================================== */
  var mobileNav = $('[data-mobile-nav]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) {
      if (mobileNav) mobileNav.classList.add('open');
    }
    if (e.target.closest('[data-menu-close]')) {
      if (mobileNav) mobileNav.classList.remove('open');
    }
  });

  /* ===========================================================
     SEARCH MODAL
     =========================================================== */
  var searchModal = $('[data-search-modal]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) {
      if (searchModal) {
        searchModal.classList.add('open');
        var input = $('input[type="search"]', searchModal);
        if (input) setTimeout(function () { input.focus(); }, 60);
      }
    }
    if (e.target.closest('[data-search-close]') || e.target === searchModal) {
      if (searchModal) searchModal.classList.remove('open');
    }
  });

  /* ===========================================================
     CART DRAWER
     =========================================================== */
  var cartDrawer = $('[data-cart-drawer]');
  var cartOverlay = $('[data-cart-overlay]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'false');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'true');
  }
  window.HAOpenCart = openCart;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openCart();
    }
    if (e.target.closest('[data-cart-close]') || e.target === cartOverlay) {
      closeCart();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      if (mobileNav) mobileNav.classList.remove('open');
      if (searchModal) searchModal.classList.remove('open');
    }
  });

  function updateCartCounts(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var countEl = doc.querySelector('[data-cart-item-count]');
    var count = countEl ? countEl.getAttribute('data-cart-item-count') : null;
    if (count !== null) {
      $all('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.style.display = parseInt(count, 10) > 0 ? '' : 'none';
      });
    }
  }

  function refreshCartSection(sectionHTML) {
    var inner = $('#cart-drawer-inner');
    if (inner && sectionHTML) {
      inner.innerHTML = getSectionHTML(sectionHTML, '#cart-drawer-inner') || sectionHTML;
    }
    if (sectionHTML) updateCartCounts(sectionHTML);
  }

  /* ---------- Add to cart ---------- */
  function addToCart(form) {
    var formData = new FormData(form);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');

    fetch(HA.routes.cart_add, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          // error (e.g. sold out)
          if (btn) {
            btn.textContent = data.description || 'Възникна грешка';
            setTimeout(function () { btn.textContent = HA.strings.addToCart; }, 2500);
          }
          return;
        }
        if (data.sections && data.sections['cart-drawer']) {
          refreshCartSection(data.sections['cart-drawer']);
        }
        openCart();
        if (btn) {
          var original = btn.getAttribute('data-label') || HA.strings.addToCart;
          btn.textContent = HA.strings.addedToCart;
          setTimeout(function () { btn.textContent = original; }, 2000);
        }
      })
      .catch(function () {})
      .finally(function () {
        if (btn) btn.classList.remove('is-loading');
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"], [data-product-form]');
    if (form) {
      e.preventDefault();
      addToCart(form);
    }
  });

  /* ---------- Change line quantity ---------- */
  function changeLine(line, quantity) {
    if (cartDrawer) cartDrawer.classList.add('is-loading');
    fetch(HA.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) {
          refreshCartSection(data.sections['cart-drawer']);
        }
        // refresh full cart page if present
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        }
      })
      .catch(function () {})
      .finally(function () {
        if (cartDrawer) cartDrawer.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var line, qty;
    var minus = e.target.closest('[data-line-minus]');
    var plus = e.target.closest('[data-line-plus]');
    var remove = e.target.closest('[data-line-remove]');

    if (minus) {
      line = parseInt(minus.getAttribute('data-line'), 10);
      qty = parseInt(minus.getAttribute('data-qty'), 10) - 1;
      changeLine(line, Math.max(0, qty));
    }
    if (plus) {
      line = parseInt(plus.getAttribute('data-line'), 10);
      qty = parseInt(plus.getAttribute('data-qty'), 10) + 1;
      changeLine(line, qty);
    }
    if (remove) {
      e.preventDefault();
      line = parseInt(remove.getAttribute('data-line'), 10);
      changeLine(line, 0);
    }
  });

  /* ===========================================================
     QUANTITY SELECTORS (product page)
     =========================================================== */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-qty-wrap]');
    if (!wrap) return;
    var input = $('input.qty-input', wrap) || $('.qty-val', wrap);
    if (!input) return;
    var current = parseInt(input.value || input.textContent, 10) || 1;
    current = plus ? current + 1 : Math.max(1, current - 1);
    if (input.value !== undefined && input.tagName === 'INPUT') {
      input.value = current;
    } else {
      input.textContent = current;
    }
  });

  /* ===========================================================
     ACCORDIONS (product details + FAQ)
     =========================================================== */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-accordion-head]');
    if (!head) return;
    var item = head.closest('[data-accordion-item]');
    if (!item) return;
    var group = item.closest('[data-accordion-single]');
    var isOpen = item.classList.contains('open');
    if (group) {
      $all('[data-accordion-item]', group).forEach(function (i) { i.classList.remove('open'); });
    }
    item.classList.toggle('open', !isOpen);
  });

  /* ===========================================================
     PRODUCT GALLERY
     =========================================================== */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var mainImg = $('[data-gallery-main] img', gallery);
    var src = thumb.getAttribute('data-image');
    if (mainImg && src) mainImg.src = src;
    $all('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });

  /* ===========================================================
     MOBILE FILTER TOGGLE (collection)
     =========================================================== */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-toggle]')) {
      var filters = $('[data-filters]');
      if (filters) filters.classList.toggle('open');
    }
  });

  /* ===========================================================
     WISHLIST (localStorage)
     =========================================================== */
  var WKEY = 'ha:wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WKEY)) || []; }
    catch (err) { return []; }
  }
  function setWishlist(list) {
    localStorage.setItem(WKEY, JSON.stringify(list));
  }
  function updateWishlistCount() {
    var count = getWishlist().length;
    $all('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }
  function syncWishlistButtons() {
    var list = getWishlist();
    $all('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      btn.classList.toggle('active', list.indexOf(handle) !== -1);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) { list.push(handle); } else { list.splice(idx, 1); }
    setWishlist(list);
    syncWishlistButtons();
    updateWishlistCount();
    if (document.body.classList.contains('template-page-wishlist')) {
      renderWishlistPage();
    }
  });

  /* ---------- Wishlist page ---------- */
  function renderWishlistPage() {
    var grid = $('[data-wishlist-grid]');
    var empty = $('[data-wishlist-empty]');
    if (!grid) return;
    var list = getWishlist();
    var shown = 0;
    $all('[data-product-handle]', grid).forEach(function (card) {
      var match = list.indexOf(card.getAttribute('data-product-handle')) !== -1;
      card.style.display = match ? '' : 'none';
      if (match) shown++;
    });
    if (empty) empty.style.display = shown === 0 ? '' : 'none';
    var counter = $('[data-wishlist-page-count]');
    if (counter) counter.textContent = shown;
  }

  /* ===========================================================
     PRODUCT CARD — click navigates (ignore inner buttons)
     =========================================================== */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-product-link]');
    if (!card) return;
    if (e.target.closest('button') || e.target.closest('a')) return;
    var url = card.getAttribute('data-product-link');
    if (url) window.location.href = url;
  });

  /* ===========================================================
     FAQ CATEGORY FILTER
     =========================================================== */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-faq-cat-pill]');
    if (!pill) return;
    var cat = pill.getAttribute('data-faq-cat-pill');
    $all('[data-faq-cat-pill]').forEach(function (p) { p.classList.remove('active'); });
    pill.classList.add('active');
    $all('[data-faq-cat]').forEach(function (item) {
      var match = cat === '*' || item.getAttribute('data-faq-cat') === cat;
      item.style.display = match ? '' : 'none';
    });
  });

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    syncWishlistButtons();
    updateWishlistCount();
    if (document.body.classList.contains('template-page-wishlist')) {
      renderWishlistPage();
    }
  });
})();
